import datLogo from "../assets/DAT_logo_transparent.png";

export default function Logo({ className = "" }) {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <img
        src={datLogo}
        alt="DAT Logo"
        className="h-full w-auto object-contain block"
      />
    </div>
  );
}
